import React, { useState, useEffect } from 'react';
import { FaSpinner, FaTimes } from 'react-icons/fa';
import { toast } from 'react-hot-toast';

const SendEmailModalMobile = ({
    openPopup,
    selectedEstimate,
    handleClose,
    sendEstimateEmail,
    sendingEstimate,
    selectedForSending,
    disableStatus
}) => {
    const [formInfo, setFormInfo] = useState({ estimationId: '' });
    const [sendingType, setSendingType] = useState('auto');
    const [labelType, setLabelType] = useState('');
    const [emailDetails, setEmailDetails] = useState({
        receiver: '',
        subject: '',
        message: '',
        id: selectedForSending,
        type: openPopup,
    });

 useEffect(() => {
         let sendType = '';
         if (openPopup == 'quotation') {
             sendType = 'send_estimate';
             setLabelType('quotation');
         } else if (openPopup == 'sales_order') {
             sendType = 'send_sales_order';
             setLabelType('sales order');
         } else {
             sendType = 'send_invoice';
             if (selectedEstimate?.is_credit_note === 1) {
                 setLabelType('credit note');   
             } else {
                 setLabelType('invoice');
             }
         }
         
         // const sendType = openPopup == 'estimate' ? 'send_estimate' : 'send_invoice';
         api.getEmailTemplate(`${sendType}`).then((res) => {
             
             let salesType = '';
 
             if (openPopup == 'quotation') {
                 salesType = 'Quotation';
             } else if (openPopup == 'sales_order') {
                 salesType = 'Sales Order';
             } else if (openPopup == 'invoice') {
                 salesType = 'Invoice';
             } else {
                 salesType = 'Credit Note';
             }
 
             // const salesType = openPopup == 'estimate' ? 'Estimate ' : openPopup == 'invoice' ? 'Invoice' : 'Credit Note ';
             if (openPopup == 'quotation') {
 
                 let subject = res?.data?.subject?.replace(/{estimate_number}/g, selectedEstimate?.estimation_number);
                 subject = subject?.replace(/{transit_company_name}/g, selectedEstimate?.transit_company?.name);
                 subject = subject?.replace(/{sale_type}/g, salesType);
 
                 if (selectedEstimate?.logistic?.name) {
                     subject = subject?.replace(/{logistic_name}/g, selectedEstimate?.logistic?.name);
                 }
                 let message = res?.data?.template?.replace(/{estimate_number}/g, selectedEstimate?.estimation_number);
                 message = message?.replace(/{sale_type}/g, salesType);
 
                 if (selectedEstimate?.transit_company?.name) {
                     message = message?.replace(/{transit_company_name}/g, selectedEstimate?.transit_company?.name);
                 }
                 if (selectedEstimate?.customer?.contact_name) {
                     message = message?.replace(/{final_customer_name}/g, selectedEstimate?.customer?.contact_name);
                 }
                 if (res?.data?.client_name) {
                     message = message?.replace(/{projectmix_user}/g, res?.data?.client_name);
                 }
 
                 const email = (selectedEstimate?.transit_company) ? selectedEstimate?.transit_company?.email : selectedEstimate?.customer?.email;
                 
                 // setEmailDetails({ ...emailDetails, subject: subject, message: message, receiver: email });
                 setEmailDetails({ ...emailDetails, subject: subject, message: message, receiver: 'info@trademixglobal.com' });
             } else if (openPopup == 'sales_order') {
 
                 let subject = res?.data?.subject?.replace(/{sales_order_number}/g, selectedEstimate?.sales_order_number);
                 subject = subject?.replace(/{transit_company_name}/g, selectedEstimate?.transit_company?.name);
                 subject = subject?.replace(/{sale_type}/g, salesType);
 
                 let message = res?.data?.template?.replace(/{sales_order_number}/g, selectedEstimate?.sales_order_number);
                 message = message?.replace(/{sale_type}/g, salesType);
 
                 if (selectedEstimate?.transit_company?.name) {
                     message = message?.replace(/{transit_company_name}/g, selectedEstimate?.transit_company?.name);
                 }
                 if (selectedEstimate?.customer?.contact_name) {
                     message = message?.replace(/{final_customer_name}/g, selectedEstimate?.customer?.contact_name);
                 }
                 if (res?.data?.client_name) {
                     message = message?.replace(/{projectmix_user}/g, res?.data?.client_name);
                 }
 
                const email = (selectedEstimate?.transit_company) ? selectedEstimate?.transit_company?.email : selectedEstimate?.customer?.email;
 
                 // setEmailDetails({ ...emailDetails, subject: subject, message: message, receiver: email });
                 setEmailDetails({ ...emailDetails, subject: subject, message: message, receiver: 'info@trademixglobal.com' });
             } else {
                 let hasLogistic = false;
 
                 if (selectedEstimate?.logistic) {
                     hasLogistic = true;
                 }
 
                 let subject = res?.data?.subject?.replace(/{estimate_number}/g, selectedEstimate?.estimation_number);
                 subject = subject?.replace(/{transit_company_name}/g, selectedEstimate?.transit_company?.name);
                 subject = subject?.replace(/{transit_company_name}/g, selectedEstimate?.transit_company?.name);
                 subject = subject?.replace(/{sale_type}/g, salesType);
 
                 if (selectedEstimate?.invoice_number) {
                     subject = subject?.replace(/{invoice_number}/g, selectedEstimate?.invoice_number);
                 }
 
                 if (hasLogistic) {
                     subject = subject?.replace(/{logistic_name}/g, selectedEstimate?.logistic?.name);
                 } else {
                     subject = subject?.replace(/{logistic_name}/g, selectedEstimate?.transit_company?.name);
                 }
 
                 let message = res?.data?.template?.replace(/{estimate_number}/g, selectedEstimate?.estimation_number);
                 message = message?.replace(/{invoice_number}/g, selectedEstimate?.invoice_number);
                 message = message?.replace(/{sale_type}/g, salesType);
                 if (selectedEstimate?.transit_company?.name) {
                     message = message?.replace(/{transit_company_name}/g, selectedEstimate?.transit_company?.name);
                     message = message?.replace(/{final_customer_name}/g, selectedEstimate?.transit_company?.name);
                     message = message?.replace(/{logistic_name}/g, selectedEstimate?.transit_company?.name);
                 } else {
                     message = message?.replace(/{transit_company_name}/g, selectedEstimate?.customer?.contact_name);
                     message = message?.replace(/{final_customer_name}/g, selectedEstimate?.customer?.contact_name);
                     message = message?.replace(/{logistic_name}/g, selectedEstimate?.customer?.contact_name);
                 }
                 // if (hasLogistic) {
                 //     if (selectedEstimate?.logistic?.contact_name) {
                 //         message = message?.replace(/{logistic_name}/g, selectedEstimate?.logistic?.contact_name);
                 //     }
                 // } else if (selectedEstimate?.transit_company?.name) {
                 //     message = message?.replace(/{logistic_name}/g, selectedEstimate?.transit_company?.contact_name);
                 // }
                 // if (selectedEstimate?.transit_company?.name) {
                 //     message = message?.replace(/{transit_company_name}/g, selectedEstimate?.transit_company?.name);
                 // }
                 // if (selectedEstimate?.customer?.contact_name) {
                 //     message = message?.replace(/{final_customer_name}/g, selectedEstimate?.customer?.contact_name);
                 // }
                 if (res?.data?.client_name) {
                     message = message?.replace(/{projectmix_user}/g, res?.data?.client_name);
                 }
                 
                const email = (selectedEstimate?.transit_company) ? selectedEstimate?.transit_company?.email : selectedEstimate?.customer?.email;
 
                 // setEmailDetails({ ...emailDetails, subject: subject, message: message, receiver: email });
                 setEmailDetails({ ...emailDetails, subject: subject, message: message, receiver: 'info@trademixglobal.com' });
             }
         });
     }, []);

    const handleSendingType = (type) => {
        setSendingType(type);
        if (type == 'auto') {
            setEmailDetails({ ...emailDetails, receiver: '' });
        }
    };

    const sendEmail = () => {
        if (sendingType == 'auto') {

            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            if (!emailRegex.test(emailDetails?.receiver)) {
                toast.error(`Please enter valid email address`);
                return false;
            } else if (emailDetails?.subject.trim() == '') {
                toast.error(`Please enter email subject`);
                return false;
            } else {
                const data = {
                    receiver: emailDetails?.receiver,
                    subject: emailDetails?.subject,
                    message: emailDetails?.message,
                    sending_type: sendingType,
                    id: selectedForSending,
                    type: openPopup
                };
                sendEstimateEmail(data);
            }
        } else {
            const data = {
                receiver: emailDetails?.receiver,
                subject: emailDetails?.subject,
                message: emailDetails?.message,
                sending_type: sendingType,
                id: selectedForSending,
                type: openPopup
            };
            sendEstimateEmail(data);
        }
    }

    if (!openPopup) return null;

    return (
        <div
            className="d-flex"
            style={{
                width: '100vw',
                height: '100dvh',
                position: 'fixed',
                left: 0,
                top: 0,
                zIndex: 20,
                background: 'rgba(0,0,0,0.07)',
                justifyContent: 'center',
                alignItems: 'end',
                paddingBottom: '90px',
                backdropFilter: 'blur(8px)', // <-- add this line
                WebkitBackdropFilter: 'blur(8px)' // <-- for Safari support
            }}
        >
            <div
                className="popup product-popup-mobile d-md-none"
                style={{
                    position: 'relative',
                    transform: 'none',
                    top: 0,
                    left: 0,
                    maxWidth: '90%',
                    background: '#fff',
                    borderRadius: 12,
                    boxShadow: 'rgb(0 0 0 / 37%) 0px 0px 20px',
                    width: '100%',
                    minHeight: '70dvh',
                    padding: '24px 16px 0 16px',
                    display: 'flex',
                    flexDirection: 'column'
                }}
            >
                {/* Header */}
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
                    <h5 style={{ fontWeight: 600, fontSize: 18, margin: 0 }}>
                        Send {labelType.charAt(0).toUpperCase() + labelType.slice(1)}
                    </h5>
                </div>

                {/* Sending type */}
                <div style={{ marginBottom: 16 }}>
                    <label style={{ fontWeight: 600, fontSize: 14 }}>
                        <input
                            type="checkbox"
                            checked={sendingType === 'auto'}
                            onChange={() => handleSendingType('auto')}
                            style={{ marginRight: 6 }}
                        />
                        Send {labelType} by email
                    </label>
                    <span style={{ fontStyle: 'italic', color: '#989898', marginLeft: 8, fontSize: 13 }}>
                        (the {labelType} will be added as an attachment to the email message)
                    </span>
                </div>

                {sendingType === 'auto' && (
                    <>
                        <div className="form-group" style={{ marginBottom: 12 }}>
                            <label className="font500">Send to</label>
                            <input
                                type="email"
                                className="form-control"
                                value={emailDetails?.receiver}
                                onChange={(e) => setEmailDetails({ ...emailDetails, receiver: e.target.value })}
                                placeholder="Enter recipient's email address"
                                style={{ marginTop: 4 }}
                            />
                        </div>
                        <div className="form-group" style={{ marginBottom: 12 }}>
                            <label className="font500">Subject</label>
                            <input
                                type="text"
                                className="form-control"
                                value={emailDetails?.subject}
                                onChange={(e) => setEmailDetails({ ...emailDetails, subject: e.target.value })}
                                placeholder="Enter email subject"
                                style={{ marginTop: 4 }}
                            />
                        </div>
                        <div className="form-group" style={{ marginBottom: 12 }}>
                            <label className="font500">Email message</label>
                            <textarea
                                className="form-control"
                                rows={8}
                                value={emailDetails?.message}
                                onChange={(e) => setEmailDetails({ ...emailDetails, message: e.target.value })}
                                style={{ resize: 'none', marginTop: 4 }}
                            />
                        </div>
                    </>
                )}

                {selectedEstimate?.email_sent === null && (
                    <div style={{ marginBottom: 16 }}>
                        <label style={{ fontWeight: 600, fontSize: 14 }}>
                            <input
                                type="checkbox"
                                checked={sendingType === 'manual'}
                                onChange={() => handleSendingType('manual')}
                                style={{ marginRight: 6 }}
                            />
                            Send {labelType} manually
                        </label>
                        <span style={{ fontStyle: 'italic', color: '#989898', marginLeft: 8, fontSize: 13 }}>
                            (the {labelType} will be marked as sent)
                        </span>
                    </div>
                )}

                {/* Sticky bottom buttons */}
                <div
                    className="btnarea"
                    style={{
                        position: 'sticky',
                        bottom: 0,
                        left: 0,
                        width: '100%',
                        background: '#fff',
                        padding: '16px 0 12px 0',
                        zIndex: 30,
                        display: 'flex',
                        gap: 10,
                        justifyContent: 'center',
                        marginTop: 'auto'
                    }}
                >
                    <button
                        className="btn btn-main"
                        onClick={sendEmail}
                        disabled={!emailDetails?.message.trim() || sendingEstimate}
                    >
                        {sendingEstimate ? (
                            <>
                                <FaSpinner className="spinner" style={{ height: '12px', width: '17px' }} /> Sending {labelType}
                            </>
                        ) : (
                            <>Send {labelType.charAt(0).toUpperCase() + labelType.slice(1)}</>
                        )}
                    </button>
                    <button className="btn new-btn-error" onClick={handleClose}>
                        <FaTimes /> Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SendEmailModalMobile;
